import { Action, createReducer, on } from '@ngrx/store';
import * as fromLockPeriodsAction from '../actions/lock-periods.actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const lockPeriodsFeatureKey = 'lockPeriods';

export interface LockPeriodsState {
  lockPeriodsResponse: IStaticDataResponse[];
  lockPeriodsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: LockPeriodsState = {
  lockPeriodsFailure: undefined,
  lockPeriodsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromLockPeriodsAction.loadLockPeriods, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromLockPeriodsAction.loadLockPeriodsSuccess, (state, action) => ({
    ...state,
    lockPeriodsResponse: action.response
  })),

  on(fromLockPeriodsAction.loadLockPeriodsFailure, (state, action) => ({
    ...state,
    lockPeriodsFailure: action.error
  }))
);

export const getLockPeriodsResponse = (state: LockPeriodsState) => state.lockPeriodsResponse;
export const getLockPeriodsFailure = (state: LockPeriodsState) => state.lockPeriodsFailure;
export const getLockPeriodsIsLoaded = (state: LockPeriodsState) => state.loaded;
